import { IQuickLinkItem } from '../../../../ui';

export function getIsWifiCta(links: IQuickLinkItem[]) {
	const isWifiCta = links.find(
		(link) =>
			link.type === 'external-link' &&
			link.url.includes('freewifi.houstonairportsystem.net'),
	);

	return !!isWifiCta;
}
